import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHelp } from '../../../hooks/useHelpMenu';
import { useTranslation } from 'react-i18next';
import { Col } from 'react-bootstrap';
import {
  Div,
  Ul,
  Li,
  StyledCol,
  ToggleHelpButton,
  HomepageButton,
  HomepageButtonTitle,
  StyledRow
} from './styled';
import { LogoHelp } from '../simple/LogoHelp';
import { appsOrigin, logoBgAppOrigin } from '../../../constants/appOrigin';
import { setHelpSectionOpen } from '../../../redux/actions/shared';
import { theme } from '../../../theme/theme';
import helpButton from '../../../assets/images/shared/help-button.svg';
import { ToggleButton, HTitle } from '../Menu/styled';
import menuIconDown from '../../../assets/images/shared/arrow-button-down.svg'

/**
 * Component for messages help
 * @component
 * @param {Boolean} backButton
 * @param {Boolean} isProduct
 * @param {Object} selectedProduct
 * @returns
 */
export const Help = ({ backButton = true, isProduct, selectedProduct, show }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isHelpOpen, tier, nextTier, listHelp, goBack, expandHelp, isHelpExpanded } = useHelp();
  const { infoProductRequest } = useSelector(state => state.user);
  const { first, sixth } = theme;
  const parseHTML = html => ({ __html: html });
  const { applications } = useSelector(state => state.user);
  let selectedApp;
  if (selectedProduct) {
    selectedApp = applications?.find(app => app.description === appsOrigin[
      selectedProduct.unique_name]);
  }

  return (
    <Div color={tier?.main_color || nextTier?.main_color
      ? `#${tier?.main_color || nextTier?.main_color}` : `${first}`}>
      <StyledRow style={!backButton ? { minHeight: 0 } : {}}>
        <StyledCol xs={12} className="d-flex py-4">
          <LogoHelp
            fetchpriority="high"
            src={
              selectedProduct ?
              (selectedApp?.image_main || logoBgAppOrigin.default) :
              (isProduct ? logoBgAppOrigin.default : infoProductRequest?.image_main || logoBgAppOrigin.default)
            }
          />
          {listHelp?.length > 0 && (
            <ToggleHelpButton
              onClick={() => dispatch(setHelpSectionOpen(!isHelpOpen))}
              src={ helpButton }
            />
          )}
        </StyledCol>
    
        {(listHelp?.length > 0 && isHelpOpen && show) && (
          <>
            <Col xs={12}>
              <ToggleButton
                onClick={() => expandHelp()}
              >
                <HTitle color={ sixth }>
                  { t("common.help") }
                </HTitle>
                <img
                  alt=""
                  src={ menuIconDown }
                  style={
                    { width: 25, height: 20, marginLeft: 10, marginRight: 10,
                      transform: isHelpExpanded ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease-in-out"  
                    }
                  }
                />
              </ToggleButton>
            </Col>
            { isHelpExpanded && (
              <Col xs={12}>
                <Ul color={ sixth }>
                  {listHelp.map(help => {
                    return (
                      <Li
                        className="p-2"
                        name={`li_help_${help.id}`}
                        key={`li_${help.id}`}
                        color={ sixth }
                      >
                        { help?.text }
                        {help?.html && (
                          <div dangerouslySetInnerHTML={parseHTML(help.html)}></div>
                        )}
                      </Li>
                    );
                  })}
                </Ul>
              </Col>
            ) }
          </>
        )}

        {(backButton && isHelpOpen) && (
          <HomepageButton onClick={() => goBack()}>
            <HomepageButtonTitle name="link_back_home">
              { t("common.backHomepage") }
            </HomepageButtonTitle>
          </HomepageButton>
        )}
      </StyledRow>
    </Div>
  );
};

Help.propTypes = {
  backButton: PropTypes.bool
};
